import React, { useState, useEffect } from "react";
import { RefreshCw } from "lucide-react";

const UserDebugPanel = () => {
  const [user, setUser] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const loadUser = () => {
      try {
        const userData = localStorage.getItem("user");
        setUser(userData ? JSON.parse(userData) : null);
      } catch {
        setUser(null);
      }
    };
    loadUser();
    const interval = setInterval(loadUser, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!user) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={() => setExpanded(!expanded)}
        className="bg-red-500 text-white px-3 py-2 rounded-lg text-xs font-semibold shadow-lg"
      >
        Debug User Data
      </button>
      {expanded && (
        <div className="mt-2 bg-bg-60 border border-bd-50 rounded-lg p-4 shadow-lg max-w-md max-h-96 overflow-y-auto">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-semibold text-fg-50">User Data Debug</h3>
            <button
              onClick={() => {
                const userData = localStorage.getItem("user");
                setUser(userData ? JSON.parse(userData) : null);
              }}
              className="text-fg-60 hover:text-fg-50"
            >
              <RefreshCw className="w-4 h-4" />
            </button>
          </div>
          <div className="space-y-2 text-xs">
            <div>
              <strong className="text-fg-50">Role:</strong>{" "}
              <span className="text-fg-60">{user.role}</span>
            </div>
            <div>
              <strong className="text-fg-50">AdminRole:</strong>{" "}
              <span className="text-fg-60">
                {user.adminRole
                  ? typeof user.adminRole === "string"
                    ? `ID: ${user.adminRole}`
                    : user.adminRole.name || "No name"
                  : "null"}
              </span>
            </div>
            {user.adminRole && typeof user.adminRole === "object" && (
              <>
                <div>
                  <strong className="text-fg-50">AdminRole ID:</strong>{" "}
                  <span className="text-fg-60">{user.adminRole._id}</span>
                </div>
                <div>
                  <strong className="text-fg-50">Allowed Routes:</strong>{" "}
                  <span className="text-fg-60">
                    {user.adminRole.allowedRoutes
                      ? `${user.adminRole.allowedRoutes.length} routes`
                      : "No routes"}
                  </span>
                </div>
                {user.adminRole.allowedRoutes && (
                  <div className="mt-2">
                    <strong className="text-fg-50 block mb-1">Routes:</strong>
                    <div className="bg-bg-50 p-2 rounded text-fg-60 max-h-32 overflow-y-auto">
                      {user.adminRole.allowedRoutes.map((route, idx) => (
                        <div key={idx} className="text-xs">
                          {route}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
            <div className="mt-4 pt-2 border-t border-bd-50 flex gap-2">
              <button
                onClick={async () => {
                  try {
                    const { verifyUser } = await import("../../../api/apiFunction/userServices");
                    const res = await verifyUser();
                    if (res?.data) {
                      const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
                      const updatedUser = {
                        ...currentUser,
                        ...res.data,
                        token: currentUser.token,
                        refreshToken: currentUser.refreshToken
                      };
                      localStorage.setItem("user", JSON.stringify(updatedUser));
                      window.dispatchEvent(new Event('storage'));
                      window.location.reload();
                    }
                  } catch (error) {
                    console.error("Failed to refresh:", error);
                  }
                }}
                className="text-xs bg-green-500 text-white px-2 py-1 rounded"
              >
                Refresh User Data
              </button>
              <button
                onClick={() => {
                  console.log("Full user object:", user);
                  console.log("AdminRole:", user.adminRole);
                  console.log("AllowedRoutes:", user.adminRole?.allowedRoutes);
                }}
                className="text-xs bg-ac-01 text-white px-2 py-1 rounded"
              >
                Log to Console
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDebugPanel;

